<mat-form-field class="chip-list" appearance="fill">
  <mat-label>Genres</mat-label>
  <mat-chip-grid #currentGenreList>
    @for (genre of genres(); track genre){
    <mat-chip-row [removable]="removable" (removed)="remove(genre)" color="primary">
      {{ genre }}
      @if (removable) {
      <mat-icon matChipRemove>cancel</mat-icon>
      }
    </mat-chip-row>
    }
    <input #genreInput placeholder="Add Genre..." [formControl]="genreCtrl" [matAutocomplete]="auto"
      [matChipInputFor]="currentGenreList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="add($event)" />
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    @for (genre of (filteredGenres | async); track genre ) {
    <mat-option [value]="genre">
      {{ genre }}
    </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>